import React from 'react';
import { Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { FactoryLabel } from '../widgets/Label';

/**
 * Метка свойства.
 *
 * Использует FactoryLabel:
 * 1. сначала пытается получить label из ontology через factory;
 * 2. если в ontology метка не найдена, FactoryLabel работает как обычный LabelInOwl.
 *
 * В режиме редактирования:
 * если компонент просмотра и компонент редактирования совпадают,
 * наименование свойства отображается светло-серым.
 */
class PropertyLabel extends React.Component {

  render() {
    const { warning, factory, isEdit, predicat, iri } = this.props;

    const propertyIri = predicat || iri;

    const viewComponent = factory?.ui?.getUIComponent
      ? factory.ui.getUIComponent(propertyIri)
      : undefined;

    const editComponent = factory?.ui?.getUIComponent
      ? factory.ui.getUIComponent(propertyIri, 'edit')
      : undefined;

    const isSameViewAndEditComponent = Boolean(
      isEdit &&
      viewComponent &&
      editComponent &&
      viewComponent === editComponent
    );

    const labelStyle = isSameViewAndEditComponent
      ? { color: '#bfbfbf' }
      : undefined;

    return (
      <div className="csi_field_div">
        <Tooltip placement="left" title={propertyIri}>
          <span>
            <span style={labelStyle}>
              <FactoryLabel
                {...this.props}
                iri={propertyIri}
              />
            </span>

            {warning && (
              <WarningOutlined
                style={{
                  float: 'right',
                  paddingRight: '5px',
                  paddingTop: '4px',
                }}
              />
            )}
          </span>
        </Tooltip>
      </div>
    );
  }
}

export default PropertyLabel;